import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationConfiguratorService {
    public static defaultLanguage = 'pt';
    public static availableLanguages = ['pt', 'en'];
    public static windowCustomLanguageProperty = '__betalabsCheckoutLanguage';

    constructor(
        public translate: TranslateService
    ) { }

    private static isCustomLanguageDefined() {
        return window.hasOwnProperty(TranslationConfiguratorService.windowCustomLanguageProperty)
            && TranslationConfiguratorService.isValidLanguage(window[TranslationConfiguratorService.windowCustomLanguageProperty]);
    }
    private static getCustomLanguage() {
        return window[TranslationConfiguratorService.windowCustomLanguageProperty];
    }
    private static isValidLanguage(lang: string) {
        return TranslationConfiguratorService.availableLanguages.indexOf(lang) > -1;
    }

    public static decideUseLanguage(browserLanguage) {
        let useLanguage = TranslationConfiguratorService.defaultLanguage;

        if (TranslationConfiguratorService.isValidLanguage(browserLanguage)) {
            useLanguage = browserLanguage;
        }
        if (TranslationConfiguratorService.isCustomLanguageDefined()) {
            useLanguage = TranslationConfiguratorService.getCustomLanguage();
        }

        return useLanguage;
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/shared/services/translation-configurator.service.ts